import React from 'react';
import ProductPage from '../components/ProductPage';

const DalcommHeadsetsPage = ({ onRequestDemo, onRequestQuote }) => {
  const productData = {
    productName: 'Dalcomm Tech Aviation Head Sets, Adapters, and Wireless Team Kits',
    tagline: 'Professional Communication Solutions for Aviation',
    description: 'High-quality aviation headsets, adapter cables, and wireless team kits designed for comfort, clarity, and compatibility with all major aircraft communication systems.',
    image: '/images/img_0317.jpeg',
    imageContain: true,
    features: [
      {
        title: 'Passive Noise Reduction',
        description: 'Superior ear seal design blocks external noise'
      },
      {
        title: 'Clear Audio',
        description: 'High-fidelity speakers for crisp communication'
      },
      {
        title: 'All-Day Comfort',
        description: 'Lightweight design with plush ear cushions'
      },
      {
        title: 'Universal Compatibility',
        description: 'Adapters for all major aircraft intercom systems'
      },
      {
        title: 'Durable Construction',
        description: 'Built to withstand daily professional use'
      },
      {
        title: 'Boom Microphone',
        description: 'Flexible, noise-canceling microphone'
      }
    ],
    specifications: [
      { label: 'Noise Reduction', value: '24 dB passive' },
      { label: 'Impedance', value: '300 ohms' },
      { label: 'Frequency Response', value: '20 Hz - 20 kHz' },
      { label: 'Weight', value: '350g' },
      { label: 'Cable Length', value: '2 meters' },
      { label: 'Warranty', value: '2 years' }
    ],
    applications: [
      'Maintenance communication',
      'Engine run-ups',
      'Ground operations',
      'Flight line coordination',
      'Hangar operations',
      'Training exercises',
      'Test flights',
      'Quality assurance'
    ]
  };

  return <ProductPage {...productData} onRequestQuote={onRequestQuote} />;
};

export default DalcommHeadsetsPage;
